/**
 * Pronto Posto – Maildaten · Deutsch (de-DE) · sprachweit geteilt
 *
 * Platz für Inhalte, die in MEHREREN deutschen Episoden auftauchen (z. B. eine generische
 * Spam-Mail, die jedes deutsche Postfach bekommt). Geteilt wird immer innerhalb einer
 * Sprache über Episoden hinweg – deshalb liegt dieser Slot unter de-DE/ und nicht unter
 * einer Episode.
 *
 * Aktuell leer. Bestehender Kandidat: die Spam-Mail "Dein neuer Job?" (id 101) in
 * ./ks02.js – sie adressiert marc.novak@ und francesca.amore@ (KS02) UND m.lange@ (KS04)
 * und ist damit bereits episodenübergreifend. Sie wurde bewusst NICHT verschoben, weil
 * das die Position im ausgelieferten Array verändern würde; der Umbau sollte den
 * Datensatz 1:1 erhalten. Verschiebung nur nach ausdrücklicher Freigabe.
 */
/* eslint-disable */

export function getEmails() {
    return []
}

export function getSpam() {
    return []
}
